module.exports = __webpack_public_path__ + "img/dlbj.80df3a30.png";